import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {AbsoluteFill, Easing, interpolate, useCurrentFrame} from 'remotion';

export const LevelsStudioRecordingComposition = () => {
	const frame = useCurrentFrame();

	return (
		<AbsoluteFill
			name="Canvas Capture"
			durationInFrames={658}
			style={{
				width: 2558,
				height: 1440,
			}}
		>
			<Video
				src="https://remotion.media/studio/effects/levels-capture-20261023-110003.mp4"
				durationInFrames={658}
				style={{
					position: 'absolute',
				}}
			/>
			<MacOSCursor
				cursor={interpolate(
					frame,
					[
						7, 22, 23, 37, 216, 224, 227, 239, 240, 241, 242, 252, 378, 385,
						386, 387, 391, 408, 411, 412, 416, 417, 418, 419, 422, 423, 442,
						446, 447, 448, 455, 457, 469, 473, 576, 578, 581, 582, 583,
					],
					[
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'col-resize',
						'auto',
						'col-resize',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'ew-resize',
						'default',
						'ew-resize',
						'default',
						'ew-resize',
						'auto',
						'ew-resize',
						'default',
						'auto',
						'default',
						'ew-resize',
						'default',
						'auto',
						'ew-resize',
						'auto',
						'default',
						'ew-resize',
						'default',
						'auto',
						'default',
						'ew-resize',
						'auto',
						'default',
						'auto',
						'row-resize',
						'auto',
					],
					{
						easing: Easing.step1,
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				)}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(
						frame,
						[0, 59, 231, 279, 369, 485, 565, 614, 620],
						[
							2.3351154128765805, 2.1016038715889227, 2.3351154128765805,
							2.1016038715889227, 2.3351154128765805, 2.1016038715889227,
							2.3351154128765805, 2.1016038715889227, 2.3351154128765805,
						],
						{
							easing: Easing.step1,
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					translate: interpolate(
						frame,
						[
							7, 8, 9, 10, 11, 12, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25,
							26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
							42, 44, 45, 48, 49, 53, 54, 55, 56, 57, 58, 59, 79, 80, 81, 82,
							83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98,
							99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111,
							112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124,
							125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137,
							138, 139, 140, 141, 142, 143, 144, 145, 147, 148, 149, 150, 165,
							166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178,
							179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191,
							192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204,
							205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217,
							218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230,
							238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250,
							251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263,
							264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276,
							277, 278, 279, 280, 291, 292, 293, 294, 295, 296, 297, 298, 299,
							300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312,
							313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 334,
							335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347,
							348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360,
							361, 362, 363, 367, 368, 377, 378, 379, 380, 381, 382, 383, 384,
							385, 386, 387, 388, 389, 390, 391, 392, 393, 406, 407, 408, 409,
							410, 411, 412, 413, 414, 415, 416, 417, 418, 419, 420, 421, 422,
							423, 424, 425, 426, 427, 428, 429, 432, 433, 434, 435, 436, 437,
							438, 439, 440, 441, 442, 443, 444, 445, 446, 447, 448, 449, 450,
							451, 452, 453, 454, 455, 456, 457, 458, 459, 460, 461, 462, 463,
							464, 465, 466, 467, 468, 469, 470, 471, 472, 473, 474, 475, 476,
							477, 478, 479, 480, 481, 482, 483, 484, 501, 502, 503, 504, 505,
							506, 507, 508, 509, 510, 511, 512, 513, 514, 515, 516, 517, 518,
							519, 520, 521, 522, 523, 524, 525, 526, 527, 528, 529, 530, 531,
							532, 533, 534, 535, 536, 537, 538, 539, 540, 541, 542, 543, 544,
							545, 546, 547, 548, 549, 550, 551, 552, 553, 575, 576, 577, 578,
							579, 580, 581, 582, 583, 584, 585, 586, 587, 588, 589, 590, 591,
							592, 593, 594, 595, 596, 597, 598, 599, 600, 601, 602, 603, 604,
							605, 606, 607, 608, 609, 610, 611, 612, 613,
						],
						[
							'1307.9656421820762px 1534.2711632503103px',
							'1333.2049560392227px 1509.0227278485825px',
							'1473.4395824359592px 1404.4533407657032px',
							'1580.37144956546px 1318.9023741353537px',
							'1856.3346593356475px 1114.9355157473333px',
							'2065.938632275065px 954.5149111916285px',
							'2065.938632275065px 954.5149111916285px',
							'2296.020472800061px 734.5488636075709px',
							'2296.020472800061px 722.2621430562242px',
							'2287.0631160209796px 704.3565510426432px',
							'2266.5761268908204px 690.2364000304052px',
							'2227.5906453492794px 666.8670028124762px',
							'2207.441153368637px 653.440089188436px',
							'2180.778878556769px 638.9915625712621px',
							'2139.2119998986495px 620.7758380419084px',
							'2103.309600425672px 615.2755466592344px',
							'2075.2790939265715px 612.3566523931386px',
							'2039.3766944535942px 612.3566523931386px',
							'2012.7144196417262px 612.3566523931386px',
							'1986.052144829858px 612.3566523931386px',
							'1963.6678744267363px 612.3566523931386px',
							'1941.2836040236148px 616.8262092380977px',
							'1926.087110750754px 618.7234905110599px',
							'1910.890617477893px 622.5180530569843px',
							'1901.5136696480604px 627.197405427319px',
							'1887.867838954063px 637.0213089416475px',
							'1878.4908911242305px 643.2604454354271px',
							'1858.6059239364533px 652.4093546507208px',
							'1851.4546329845189px 655.1914257480934px',
							'1848.0979045785086px 657.2985025464312px',
							'1846.310081840525px 658.1832923708415px',
							'1846.310081840525px 658.1832923708415px',
							'1845.6350875414905px 658.1832923708415px',
							'1844.9600932424557px 658.1832923708415px',
							'1844.9600932424557px 658.1832923708415px',
							'1844.9600932424557px 658.7944358578053px',
							'1844.9600932424557px 658.7944358578053px',
							'1844.3580713000736px 658.7944358578053px',
							'1844.3580713000736px 658.7944358578053px',
							'1844.3580713000736px 658.192413915423px',
							'1844.3580713000736px 658.192413915423px',
							'1843.4641599310817px 657.4535688043176px',
							'1843.4641599310817px 655.8208123242202px',
							'1843.4641599310817px 655.8208123242202px',
							'1843.4641599310817px 655.4924367192845px',
							'1843.4641599310817px 655.4924367192845px',
							'1843.7469278131098px 655.1640611143487px',
							'1844.4401652013075px 655.1640611143487px',
							'1845.2519826690655px 655.1640611143487px',
							'1846.009070869334px 655.1640611143487px',
							'1846.738794435858px 655.1640611143487px',
							'1848.9462082245927px 655.1640611143487px',
							'1849.81275495984px 655.1640611143487px',
							'1851.6279423315682px 655.1640611143487px',
							'1853.3427927128994px 655.1640611143487px',
							'1854.2549471710545px 655.1640611143487px',
							'1855.9971621861303px 655.1640611143487px',
							'1856.8819520105405px 655.1640611143487px',
							'1857.7484987457876px 655.1640611143487px',
							'1860.393746674437px 655.1640611143487px',
							'1861.2785364988472px 655.1640611143487px',
							'1863.7504750804471px 655.1640611143487px',
							'1865.310259203892px 655.1640611143487px',
							'1867.4903083588822px 655.1640611143487px',
							'1867.4903083588822px 655.1640611143487px',
							'1869.113943294398px 655.1640611143487px',
							'1871.5858818759978px 655.1640611143487px',
							'1873.4284338814707px 654.3248790128462px',
							'1875.2709858869437px 654.2610282007754px',
							'1877.104416347835px 654.2427851116123px',
							'1878.883117541237px 654.2336635670307px',
							'1880.6526971900576px 654.2336635670307px',
							'1883.1337573162389px 654.2336635670307px',
							'1887.5120987153825px 654.2336635670307px',
							'1889.2178275521323px 654.2336635670307px',
							'1892.6657714039577px 654.2336635670307px',
							'1897.518433121342px 654.2336635670307px',
							'1901.8602883421593px 654.2336635670307px',
							'1908.2362480046622px 654.2336635670307px',
							'1912.6237109483873px 653.0296196822662px',
							'1916.0625332556315px 652.99313350394px',
							'1919.4010185724783px 652.99313350394px',
							'1921.8912002432412px 652.99313350394px',
							'1922.949299414701px 652.99313350394px',
							'1927.0175082980718px 652.99313350394px',
							'1930.9306509235564px 652.99313350394px',
							'1933.3843464159932px 652.99313350394px',
							'1939.9336154255454px 652.99313350394px',
							'1942.7065649783365px 652.99313350394px',
							'1945.3609344515671px 652.99313350394px',
							'1947.9788177464718px 652.99313350394px',
							'1952.2020928877291px 652.99313350394px',
							'1954.5736944789319px 652.99313350394px',
							'1955.276053411711px 652.99313350394px',
							'1957.0273899713686px 652.99313350394px',
							'1958.86082043226px 652.99313350394px',
							'1960.6942508931513px 652.99313350394px',
							'1962.5459244432059px 652.99313350394px',
							'1964.3884764486788px 652.99313350394px',
							'1966.2310284541516px 652.99313350394px',
							'1967.0884536448173px 652.99313350394px',
							'1968.8215471153117px 652.99313350394px',
							'1970.5911267641322px 652.99313350394px',
							'1972.032330808017px 652.99313350394px',
							'1972.9171206324272px 652.99313350394px',
							'1973.8475181797453px 652.99313350394px',
							'1976.3559429396712px 652.99313350394px',
							'1978.1528872222364px 652.99313350394px',
							'1979.9498315048015px 652.99313350394px',
							'1981.7102896090405px 652.99313350394px',
							'1982.5677147997062px 652.99313350394px',
							'1983.3339245445563px 652.99313350394px',
							'1983.3339245445563px 652.99313350394px',
							'1983.990675754428px 652.99313350394px',
							'1983.990675754428px 652.99313350394px',
							'1984.59269769681px 652.99313350394px',
							'1984.59269769681px 652.99313350394px',
							'1984.6383054197179px 652.99313350394px',
							'1984.6383054197179px 652.99313350394px',
							'1983.443383079535px 652.99313350394px',
							'1983.443383079535px 652.99313350394px',
							'1981.701168064459px 651.3968632021689px',
							'1979.9498315048015px 650.8404489826944px',
							'1975.7630425418706px 649.8918083462133px',
							'1973.747181189348px 649.3992449388097px',
							'1970.9468670028125px 648.4688473914916px',
							'1970.0164694554946px 648.4506043023285px',
							'1969.1043149973395px 648.441482757747px',
							'1967.4715585172423px 648.4323612131654px',
							'1965.8661666708897px 648.4323612131654px',
							'1965.1455646489474px 648.4323612131654px',
							'1963.494565079687px 648.4323612131654px',
							'1961.0317480426686px 648.4323612131654px',
							'1957.6750196366586px 648.4323612131654px',
							'1953.497352218309px 648.4323612131654px',
							'1949.228469354144px 648.4323612131654px',
							'1944.1568905668028px 648.4323612131654px',
							'1939.1309195023691px 648.4323612131654px',
							'1933.0924569893837px 648.4323612131654px',
							'1925.9411660374492px 649.654648187093px',
							'1917.6770466465655px 649.654648187093px',
							'1910.9727113791268px 649.654648187093px',
							'1905.6001216205946px 650.8769351610206px',
							'1899.5251729292827px 650.8769351610206px',
							'1897.7373501912991px 650.8769351610206px',
							'1891.771860034966px 650.8769351610206px',
							'1887.5212202599641px 650.8769351610206px',
							'1885.0584032229458px 650.8769351610206px',
							'1882.2307244026656px 650.8769351610206px',
							'1878.8739959966556px 650.8769351610206px',
							'1876.885499277878px 650.8769351610206px',
							'1873.0453290090456px 650.8769351610206px',
							'1869.515291255986px 650.8769351610206px',
							'1867.7639546963287px 650.8769351610206px',
							'1861.8623153520664px 650.8769351610206px',
							'1858.2593052423545px 650.8769351610206px',
							'1851.509362252008px 650.8769351610206px',
							'1849.748904147769px 650.8769351610206px',
							'1843.8563863480883px 650.8769351610206px',
							'1842.1780221450833px 650.8769351610206px',
							'1838.8212937390733px 650.8769351610206px',
							'1835.3551067980845px 651.214432310538px',
							'1832.5730357007121px 651.6796310841969px',
							'1829.1889426609573px 651.7343603516863px',
							'1826.3886284744217px 651.7343603516863px',
							'1823.0136569792485px 652.1357083132744px',
							'1820.2863151493655px 652.5917855423519px',
							'1817.6137025869714px 653.0478627714293px',
							'1814.1931233688906px 653.4856969113437px',
							'1810.8363949628804px 653.4856969113437px',
							'1807.4796665568704px 653.4856969113437px',
							'1804.9438771631997px 653.4856969113437px',
							'1800.9030329135735px 654.4799452707325px',
							'1797.9294093799883px 654.653254617782px',
							'1794.5635594293967px 654.6806192515267px',
							'1791.0882509438266px 654.6806192515267px',
							'1786.9197050700586px 655.7934476904757px',
							'1784.0920262497784px 655.8755415917095px',
							'1780.6532039425344px 655.8755415917095px',
							'1778.8288950262245px 655.8755415917095px',
							'1778.8288950262245px 655.8755415917095px',
							'1778.3819393417286px 656.7785745052829px',
							'1778.3819393417286px 656.7785745052829px',
							'1782.4227835913548px 656.7785745052829px',
							'1802.8459219094434px 656.7785745052829px',
							'1838.7300782932577px 656.7785745052829px',
							'1869.6521144247092px 656.7785745052829px',
							'1939.3680796614894px 656.7785745052829px',
							'2004.970228291991px 656.7785745052829px',
							'2046.5188638609472px 660.034965920896px',
							'2093.0296196822665px 662.9447386424101px',
							'2115.395646996225px 662.9447386424101px',
							'2134.1677857450527px 665.1795170648896px',
							'2143.526490485722px 665.1795170648896px',
							'2146.8649758025695px 666.4018040388173px',
							'2148.63455545139px 666.4018040388173px',
							'2149.5193452758003px 666.4018040388173px',
							'2150.249068842324px 666.4018040388173px',
							'2150.249068842324px 666.4018040388173px',
							'2150.8693338738694px 666.4018040388173px',
							'2153.5237033471003px 666.4018040388173px',
							'2155.293282995921px 666.4018040388173px',
							'2157.0628626447415px 666.4018040388173px',
							'2158.8324422935616px 666.4018040388173px',
							'2159.5621658600858px 666.4018040388173px',
							'2159.5621658600858px 666.4018040388173px',
							'2160.228038614539px 666.4018040388173px',
							'2160.228038614539px 666.4018040388173px',
							'2160.8483036460843px 666.4018040388173px',
							'2160.8483036460843px 665.6629589277118px',
							'2160.8483036460843px 665.6629589277118px',
							'2160.8483036460843px 664.2491195175717px',
							'2161.7330934704946px 664.2491195175717px',
							'2162.4628170370183px 663.5102744064662px',
							'2162.4628170370183px 661.8775179263689px',
							'2163.3476068614286px 661.8775179263689px',
							'2163.3476068614286px 660.9836065573771px',
							'2163.3476068614286px 660.3086122583425px',
							'2163.3476068614286px 659.6336179593078px',
							'2164.232396685839px 658.739706590316px',
							'2164.232396685839px 657.8457952213241px',
							'2164.232396685839px 657.1069501102187px',
							'2164.9621202523626px 655.4741936301214px',
							'2164.9621202523626px 655.4741936301214px',
							'2164.9621202523626px 655.0910887576963px',
							'2164.9621202523626px 655.0910887576963px',
							'2165.2448881343907px 654.7079838852712px',
							'2168.036080776345px 654.7079838852712px',
							'2168.036080776345px 654.7079838852712px',
							'2174.8863607570884px 654.7079838852712px',
							'2181.1163757062864px 654.7079838852712px',
							'2187.474092279626px 654.7079838852712px',
							'2194.4247092507667px 654.7079838852712px',
							'2202.7982871766285px 654.7079838852712px',
							'2205.2975903919732px 654.7079838852712px',
							'2213.5434666936935px 654.7079838852712px',
							'2222.902171434363px 654.7079838852712px',
							'2230.281501000836px 654.7079838852712px',
							'2238.6915651050244px 654.7079838852712px',
							'2243.717536169458px 654.7079838852712px',
							'2246.0617731269163px 654.7079838852712px',
							'2249.3546507208557px 654.7079838852712px',
							'2252.0911140953203px 654.7079838852712px',
							'2257.007626624775px 654.7079838852712px',
							'2263.4930448222567px 654.7079838852712px',
							'2269.1392809182357px 654.7079838852712px',
							'2273.262219069096px 654.7079838852712px',
							'2278.1696100539693px 654.7079838852712px',
							'2282.11923885778px 654.7079838852712px',
							'2286.2148123748957px 654.7079838852712px',
							'2288.0208782020422px 654.7079838852712px',
							'2289.845187118352px 654.7079838852712px',
							'2291.687739123825px 654.7079838852712px',
							'2293.5211695847165px 654.7079838852712px',
							'2295.372843134771px 654.7079838852712px',
							'2297.169787417336px 654.7079838852712px',
							'2298.9393670661566px 654.7079838852712px',
							'2299.824156890567px 654.7079838852712px',
							'2300.5630020016724px 654.7079838852712px',
							'2300.5630020016724px 654.7079838852712px',
							'2300.60860972458px 654.7079838852712px',
							'2300.043073960524px 654.7079838852712px',
							'2298.5106544708237px 654.7079838852712px',
							'2297.6258646464134px 654.7079838852712px',
							'2295.19041224314px 654.7079838852712px',
							'2292.5086781361647px 654.7079838852712px',
							'2289.8360655737706px 654.7079838852712px',
							'2287.355005447589px 654.7079838852712px',
							'2282.8854486026303px 654.7079838852712px',
							'2271.173385359921px 654.7079838852712px',
							'2257.2995160513847px 654.7079838852712px',
							'2242.103022778524px 655.6566245217524px',
							'2226.906529505663px 657.5539057947146px',
							'2209.5573517115567px 659.1775407302304px',
							'2197.2341449818837px 659.9984797425698px',
							'2187.2642967542506px 660.0440874654776px',
							'2182.402513492285px 660.0440874654776px',
							'2172.7336762358427px 660.0440874654776px',
							'2163.3476068614286px 660.0440874654776px',
							'2157.309144348443px 660.0440874654776px',
							'2149.254820482935px 660.0440874654776px',
							'2141.182253528264px 661.3211037068944px',
							'2137.396812526921px 661.4670484201991px',
							'2128.950262244407px 661.5673854105962px',
							'2117.676033141612px 661.5765069551778px',
							'2115.651050244508px 661.5765069551778px',
							'2110.2693389413944px 661.5765069551778px',
							'2110.2693389413944px 661.5765069551778px',
							'2107.742671092305px 661.5765069551778px',
							'2107.742671092305px 661.5765069551778px',
							'2107.0038259811995px 661.5765069551778px',
							'2107.0038259811995px 661.5765069551778px',
							'2110.123394228089px 666.8305166341501px',
							'2113.917956774014px 674.419641725999px',
							'2130.929637418603px 696.2474979096461px',
							'2142.1035295310007px 716.378746801125px',
							'2155.512200065878px 734.2752172701245px',
							'2170.964096587022px 765.8813692451922px',
							'2190.3565003673957px 798.8466313629108px',
							'2205.2975903919732px 829.2669825423773px',
							'2225.045734411027px 863.281222286974px',
							'2233.309853801911px 882.0533610358021px',
							'2236.7669191983177px 894.3218384979857px',
							'2239.8864874452074px 903.6805432386551px',
							'2243.215851217473px 909.4727240479389px',
							'2243.215851217473px 911.9264195403755px',
							'2244.4381381914004px 915.2649048572225px',
							'2244.4381381914004px 924.6236095978919px',
							'2244.4381381914004px 924.6236095978919px',
							'2243.7540223477845px 922.3705880862493px',
							'2243.7540223477845px 922.3705880862493px',
							'2243.7540223477845px 922.3705880862493px',
							'2243.7540223477845px 922.3705880862493px',
							'2243.7540223477845px 922.3705880862493px',
							'2243.7540223477845px 922.3705880862493px',
							'2243.7540223477845px 922.3705880862493px',
							'2243.7540223477845px 922.3705880862493px',
							'2243.7540223477845px 922.3705880862493px',
							'2243.7540223477845px 922.3705880862493px',
							'2243.7540223477845px 922.3705880862493px',
							'2243.7540223477845px 922.3705880862493px',
							'2243.7540223477845px 922.3705880862493px',
							'2243.7540223477845px 922.3705880862493px',
							'2243.7540223477845px 922.3705880862493px',
							'2243.7540223477845px 922.3705880862493px',
							'2243.7540223477845px 922.3705880862493px',
							'2243.7540223477845px 922.3705880862493px',
							'2243.7540223477845px 922.3705880862493px',
							'2243.7540223477845px 922.3705880862493px',
							'2243.7540223477845px 922.3705880862493px',
							'2243.7540223477845px 922.3705880862493px',
							'2243.7540223477845px 922.3705880862493px',
							'2243.7540223477845px 922.3705880862493px',
							'2244.4381381914004px 920.7013454278258px',
							'2244.4381381914004px 915.7757113537892px',
							'2244.4381381914004px 913.312894316771px',
							'2244.4381381914004px 909.0622545417691px',
							'2244.4381381914004px 908.1683431727773px',
							'2244.4381381914004px 906.53558669268px',
							'2244.4381381914004px 904.7477639546963px',
							'2244.4381381914004px 902.0660298477209px',
							'2244.4381381914004px 897.1403957736844px',
							'2244.4381381914004px 887.7634479438518px',
							'2244.4381381914004px 878.3865001140193px',
							'2244.4381381914004px 866.0997795626727px',
							'2244.4381381914004px 856.7228317328402px',
							'2244.4381381914004px 849.1245850964096px',
							'2242.869232523374px 839.7476372665772px',
							'2242.869232523374px 827.4609167152305px',
							'2241.3003268553475px 820.3096257632959px',
							'2241.3003268553475px 815.3839916892595px',
							'2241.3003268553475px 813.5961689512758px',
							'2241.3003268553475px 810.2394405452657px',
							'2241.3003268553475px 808.4516178072821px',
							'2241.3003268553475px 805.094889401272px',
							'2241.3003268553475px 803.3070666632883px',
							'2241.3003268553475px 801.5192439253047px',
							'2240.406415486356px 799.7314211873211px',
							'2240.406415486356px 798.9925760762156px',
							'2239.512504117364px 798.2537309651101px',
							'2239.512504117364px 798.2537309651101px',
							'2239.512504117364px 797.5148858540047px',
							'2239.512504117364px 797.5148858540047px',
							'2239.512504117364px 796.8946208224593px',
							'2239.512504117364px 796.2196265234247px',
							'2239.512504117364px 796.2196265234247px',
							'2239.512504117364px 794.5868700433274px',
							'2239.512504117364px 792.9541135632301px',
							'2239.512504117364px 792.2152684521246px',
							'2239.512504117364px 791.4764233410191px',
							'2239.512504117364px 790.5825119720273px',
							'2239.512504117364px 789.8436668609219px',
							'2239.512504117364px 789.1048217498163px',
							'2238.618592748372px 785.5291762738491px',
							'2238.618592748372px 784.6352649048573px',
							'2238.618592748372px 782.8474421668736px',
							'2237.7246813793804px 781.05961942889px',
							'2237.7246813793804px 779.2717966909064px',
							'2236.985836268275px 777.6390402108091px',
							'2236.985836268275px 777.6390402108091px',
							'2236.985836268275px 776.9640459117744px',
							'2236.985836268275px 776.225200800669px',
							'2236.985836268275px 775.4863556895634px',
							'2236.985836268275px 774.747510578458px',
							'2236.091924899283px 774.747510578458px',
							'2236.091924899283px 774.747510578458px',
							'2236.3655712367295px 774.747510578458px',
							'2240.6070894671498px 774.747510578458px',
							'2246.526971900575px 774.747510578458px',
							'2253.7785998429067px 774.747510578458px',
							'2260.0542225150125px 774.747510578458px',
							'2265.207895203588px 774.747510578458px',
							'2270.179137000532px 774.747510578458px',
							'2275.0865279854056px 774.747510578458px',
							'2279.4831124737125px 774.747510578458px',
							'2284.6641497960322px 774.747510578458px',
							'2291.687739123825px 772.7134061367725px',
							'2300.918742240353px 772.3303012643474px',
							'2310.5419717738873px 771.6005776978235px',
							'2317.237185496744px 770.761395596321px',
							'2324.525299617402px 770.6975447842501px',
							'2328.2377682620927px 770.679301695087px',
							'2332.4428003141866px 770.6610586059239px',
							'2335.790407175615px 770.6519370613424px',
							'2339.9133453264753px 770.6519370613424px',
							'2344.6930346872073px 770.6519370613424px',
							'2348.095370816125px 770.6519370613424px',
							'2351.452099222135px 770.6519370613424px',
							'2353.2490435047002px 770.6519370613424px',
							'2353.2490435047002px 770.6519370613424px',
							'2354.8453138064715px 770.6519370613424px',
							'2355.7209820863px 770.6519370613424px',
							'2357.4267109230495px 770.6519370613424px',
							'2359.205412116452px 770.6519370613424px',
							'2361.7594445992854px 770.6519370613424px',
							'2364.505029518332px 770.6519370613424px',
							'2367.679327032711px 770.6519370613424px',
							'2372.3860440367903px 770.6519370613424px',
							'2374.8853472521346px 770.6519370613424px',
							'2380.987660577191px 770.6519370613424px',
							'2385.98626700788px 770.6519370613424px',
							'2393.575392099729px 770.6519370613424px',
							'2395.363214837713px 770.2049813768465px',
							'2398.8020371449566px 769.748904147769px',
							'2402.140522461804px 769.748904147769px',
							'2405.4790077786506px 769.748904147769px',
							'2407.248587427471px 769.748904147769px',
							'2408.1333772518815px 769.748904147769px',
							'2408.9451947196394px 769.748904147769px',
							'2408.9451947196394px 769.748904147769px',
							'2409.6110674740926px 769.748904147769px',
							'2409.6110674740926px 769.748904147769px',
							'2410.2313325056375px 769.748904147769px',
							'2410.9975422504876px 769.748904147769px',
							'2411.8093597182456px 769.748904147769px',
							'2413.42387310918px 769.748904147769px',
							'2413.42387310918px 769.748904147769px',
							'2414.0806243190514px 769.748904147769px',
							'2414.0806243190514px 769.748904147769px',
							'2412.931309701776px 770.314439911825px',
							'2377.9045785086278px 796.5662452175235px',
							'2349.0531329971877px 814.5904173106646px',
							'2288.2397952719994px 855.9748650771531px',
							'2127.5181797451037px 970.9792991613247px',
							'1989.1899561659109px 1059.385309245699px',
							'1870.0169762079713px 1142.1542047786759px',
							'1772.0515874021335px 1207.9205412116453px',
							'1678.3824460942053px 1277.9831251425242px',
							'1631.899054906631px 1310.5105531203285px',
							'1544.6332378949503px 1380.7373248536753px',
							'1531.7444954012212px 1391.044670230826px',
							'1505.2737730255658px 1411.6593609851268px',
							'1483.4276737527555px 1428.671041629716px',
							'1459.8758456431956px 1452.204626650113px',
							'1442.9827450781665px 1464.6008057364381px',
							'1425.068031520004px 1478.0094762713154px',
							'1409.8715382471432px 1485.5986013631643px',
							'1400.4945904173107px 1491.837737856944px',
							'1391.1176425874783px 1496.5170902272785px',
							'1383.9663516355438px 1500.5305698431603px',
							'1376.815060683609px 1504.5440494590418px',
							'1369.6637697316746px 1508.885904679859px',
							'1362.5124787797401px 1511.6679757772317px',
							'1357.5868447057035px 1514.1125497250869px',
							'1343.5214229609549px 1518.7919020954216px',
							'1338.8329490460385px 1520.3516862188665px',
							'1329.456001216206px 1523.4712544657564px',
							'1320.0790533863735px 1525.0310385892012px',
							'1310.702105556541px 1526.590822712646px',
							'1305.7764714825043px 1526.590822712646px',
							'1299.956926039476px 1529.0353966605012px',
							'1295.0312919654396px 1530.2576836344288px',
							'1291.6745635594295px 1531.4799706083563px',
							'1288.3178351534193px 1531.4799706083563px',
							'1286.685078673322px 1531.4799706083563px',
							'1286.685078673322px 1531.4799706083563px',
							'1285.9462335622165px 1531.4799706083563px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			/>
		</AbsoluteFill>
	);
};
